<template>
    <modal
        :active="active"
        @closed="$emit('closed', true)"
        :title="title()"
    >
        <form-field
            label="Navn"
            :error="error.name"
        >
            <input-text
                v-model="form.name"
                :error="error.name"
            />
        </form-field>

        <form-field
            label="Initialer"
            :error="error.initials"
        >
            <input-text
                v-model="form.initials"
                :error="error.initials"
            />
        </form-field>

        <form-field
            label="E-mail"
            :error="error.email"
        >
            <input-text
                v-model="form.email"
                :error="error.email"
            />
        </form-field>

        <form-field
            inner-container-class="select is-fullwidth"
            label="Rolle"
            :error="error.role"
        >
            <input-select
                v-model="form.role"
                :error="error.role"
                class="control"
                :options="roles"
            />
        </form-field>

        <form-field
            label="Password"
            :error="error.password"
        >
            <input-text
                type="password"
                v-model="form.password"
                :error="error.password"
            />
        </form-field>

        <form-field
            label="Bekræft password"
            :error="error.password_confirmation"
        >
            <input-text
                type="password"
                v-model="form.password_confirmation"
                :error="error.password_confirmation"
            />
        </form-field>
        <span v-if="isEdit">Password felter skal kun udfyldes hvis password ønskes ændret.</span>

        <template v-slot:footer class="has-space-between">
            <div class="footer-spacer">
                <div>
                    <button class="button is-danger is-flex-left" @click="reset">Nulstil</button>
                    <button class="button is-default" @click="$emit('closed', true)">Annuller</button>
                    <button class="button is-primary" @click="submit">{{ saveButtonText }}</button>
                </div>
                <button class="button is-danger" @click="remove" v-if="isEdit">Slet</button>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import { FormField, InputText, InputSelect } from '@elems/form'

export default {
    components: {
        Modal,
        FormField,
        InputText,
        InputSelect,
    },
    props: {
        active: Boolean,
        userId: [Number, Boolean],
    },
    data() {
        return {
            roles: [
                {title:'Bruger', value:'user'},
                {title:'Administrator', value:'admin'},
            ],
            form: {
                name: '',
                initials: '',
                email: '',
                role: '',
                password: '',
                password_confirmation: '',
            },
            error: [],
        }
    },

    watch: {
        userId() {
            this.reset()
        }
    },

    computed: {
        isEdit() {
            return this.userId !== false
        },
        saveButtonText() {
            return this.isEdit ? 'Gem' : 'Opret'
        }
    },

    methods: {
        title() {
            return this.isEdit
                ? 'Rediger bruger'
                : 'Opret bruger'
        },

        submit() {
            return this.isEdit
                ? this.update()
                : this.create()
        },

        create() {
            window.axios.post('/api/settings/users', this.form)
                .then(({data}) => {
                    this.$emit('closed')
                    this.$store.dispatch('addUser', data)
                    this.$store.dispatch('setSuccess', 'Brugeren blev oprettet')
                    this.reset()
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.error = error.response.data.errors
                    }
                })
        },

        update() {
            let payload = {
                name: this.form.name,
                initials: this.form.initials,
                email: this.form.email,
                role: this.form.role,
            }

            if (this.form.password !== '' || this.form.password_confirmation !== '') {
                payload['password'] = this.form.password
                payload['password_confirmation'] = this.form.password_confirmation
            }

            window.axios.put('/api/settings/users/' + this.userId, payload)
                .then(({data}) => {
                    this.$emit('closed')
                    this.$store.dispatch('updateUser', data)
                    this.$store.dispatch('setSuccess', 'Brugeren blev opdateret')
                    this.reset()
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.error = error.response.data.errors
                    }
                })
        },

        reset() {
            if (this.isEdit) {
                const user = this.$store.getters.findUser(this.userId)
                this.form = {
                    name: user.name,
                    initials: user.initials,
                    email: user.email,
                    role: user.role,
                    password: '',
                    password_confirmation: '',
                }
            } else {
                this.form = {
                    name: '',
                    initials: '',
                    email: '',
                    role: '',
                    password: '',
                    password_confirmation: '',
                }
            }
            this.error = []
        },

        remove() {
            if (!confirm('Er du sikker på du vil slette ' + this.form.name + '?')) {
                return
            }

            window.axios.delete('/api/settings/users/' + this.userId)
                .then(() => {
                    this.$emit('closed')
                    this.$store.dispatch('removeUser', this.userId)
                    this.$store.dispatch('setSuccess', 'Brugeren blev slettet')
                })
                .catch(error => {
                    console.error(error)
                    this.$store.dispatch('setError', 'Brugeren kunne ikke slettes')
                })
        },
    }
}
</script>

<style lang="scss" scoped>
.footer-spacer {
    width: 100%;
    display: flex;
    flex-direction:row-reverse;
    justify-content: space-between;
}
</style>
